import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useBrand } from '@aviv-unified-frontend/runtime/brand';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { initializeGatewayModule } from '@price-pages-agency-cards/src/infrastructure/gateway/agency.module';
import { logger } from '@price-pages-agency-cards/src/infrastructure/logger';
import { Brand } from '@shared-utils/domain/brand.entity';
import { initializeStore, useAgencyStore } from '../hooks/useAgencyHook';
const gateway = initializeGatewayModule();
initializeStore(gateway);
export const DataProvider = ({ agencyId, agencyIds, postalCode, children }) => {
    const { locale } = useLocale();
    const { id } = useBrand();
    const brand = new Brand(id).getEnumValue();
    const fetchAgencyById = useAgencyStore((state) => state.fetchAgencyById);
    const fetchAgenciesByIds = useAgencyStore((state) => state.fetchAgenciesByIds);
    const fetchRecommendedAgencies = useAgencyStore((state) => state.fetchRecommendedAgencies);
    useEffect(() => {
        if (agencyId) {
            fetchAgencyById({ brand, id: agencyId, locale: locale });
        }
    }, [agencyId, brand, locale, fetchAgencyById]);
    useEffect(() => {
        if (agencyIds?.length) {
            fetchAgenciesByIds({ brand, ids: agencyIds, locale: locale });
        }
    }, [agencyIds, brand, fetchAgenciesByIds, locale]);
    useEffect(() => {
        if (postalCode) {
            fetchRecommendedAgencies({ brand, postalCode });
        }
    }, [postalCode, brand, fetchRecommendedAgencies]);
    const hasValidProps = Boolean(agencyId || postalCode || (agencyIds && agencyIds.length > 0));
    if (!hasValidProps) {
        logger.warn('DataProvider: No valid query parameters provided (agencyId, postalCode, or agencyIds)');
    }
    return _jsx(_Fragment, { children: children });
};
